import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../AuthContext";
import { useFleetApi, type EscalationRow } from "./api";
import BulkRejectBar from "./BulkRejectBar";
import EscalationCard, { ageLabel } from "./EscalationCard";

export default function Escalations() {
  const { token, logout } = useAuth();
  const { fetchEscalationsOpen } = useFleetApi(token, logout);
  const [rows, setRows] = useState<EscalationRow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [includeTest, setIncludeTest] = useState(false);

  const load = useCallback(() => {
    let alive = true;
    fetchEscalationsOpen({ limit: 50, includeTest })
      .then(r => { if (alive) setRows(r); })
      .catch(e => { if (alive) setErr(String(e)); });
    return () => { alive = false; };
  }, [fetchEscalationsOpen, includeTest]);

  useEffect(() => {
    return load();
  }, [load]);

  const oldest = rows && rows.length > 0
    ? ageLabel(rows[rows.length - 1].created_at)
    : null;

  return (
    <section>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          marginBottom: "4px",
          flexWrap: "wrap",
        }}
      >
        <span className="meta">
          {rows == null
            ? "Loading…"
            : rows.length === 0
            ? "0 open"
            : `${rows.length} open · oldest ${oldest}`}
        </span>
        <label className="meta" style={{ display: "flex", alignItems: "center", gap: "0.4rem", cursor: "pointer" }}>
          <input
            type="checkbox"
            checked={includeTest}
            onChange={e => setIncludeTest(e.target.checked)}
          />
          Show test traffic
        </label>
      </div>
      {rows && rows.length > 0 && <BulkRejectBar rows={rows} onDone={load} />}
      <p className="page-lede">
        Each card is a decision the agent is asking a human to make. Pick an option,
        edit the reply, or reject. Anyone with portal access can resolve it.
      </p>

      {err && (
        <p style={{ color: "var(--crit)", fontSize: "12.5px" }}>{err}</p>
      )}

      {rows && rows.length === 0 && !err && (
        <p className="muted">No open escalations.</p>
      )}

      {rows &&
        rows.map(r => (
          <EscalationCard
            key={r.id}
            row={r}
            onResolved={load}
          />
        ))}
    </section>
  );
}
